import React from 'react'
import Field from '../common/Field'
import Validator from '../common/Validator'
import Reflux from 'reflux'
import Store from '../../store/store'
import api from '../../source/api'
import Alert from '../common/alert'

class Passwordreset extends Reflux.Component {

    constructor() {
        super()
        this.state = {
            fields: {
                email: {value: '', error: '', role: {required: true}}
            },
            message: '',
            type: 'success',
            error: false,
            loading: false,
            success: ''
        }
        this.store = Store
    }

    setValue(name, value, error) {
        let fields = this.state.fields;
        fields[name].value = value
        fields[name].error = error
        this.setState({fields: fields})
    }

    submit() {
        let validator = Validator.validate(this.state.fields)
        if (validator.error) {
            this.setState({
                fields: validator.fields,
                error: validator.error
            });
            return;
        }
        api.post({url: 'user/forgottpassword', data: {email: this.state.fields.email.value}}).then((response) => {
            if (response.status === 200) {
                this.setState({
                    type: 'success',
                    message: 'A megadott email címre elküldtük a jelszó beállításához szükséges linket.'
                })
            }
        }).catch((err) => {
            this.setState({type: 'danger'})
            if (err.response.data === 'STATUS_DISABLED') {
                this.setState({message: 'Az ön fiókja inaktiválva lett. Kérjük vegye fel velünk a kapcsolatot.'})
            } else {
                this.setState({message: 'Hiba történt feldolgozás közben, kérjük lépjen kapcsolatba velünk a következő email címen. info@beeker.hu'})
            }
        })
    }

    render() {
        return (
            <div className="site-login">
                <h1 className="offset-md-4 col-lg-4 text-center">Elfelejtett jelszó</h1>
                <p className="offset-md-3 col-lg-6 text-center">Kérjük adja meg a regisztrációnál használt email címét:</p>

                <div className="row">
                    <div className="col-lg-4 offset-md-4">
                        {this.state.message ? <Alert type={this.state.type} message={this.state.message}/> : null}
                        <Field
                            type="email"
                            id="login-email"
                            name="email"
                            label="Email cím"
                            classLabel="control-label"
                            classInput="form-control"
                            setValue={this.setValue.bind(this)}
                            state={this.state}
                            style={{width: '100%'}}
                        />
                        <div className="form-group  text-center">
                            <br/>
                            <button type="submit" onClick={() => this.submit()} className="btn green-btn" name="login-button">Küldés</button>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

export default Passwordreset


// WEBPACK FOOTER //
// ./src/components/pages/passwordreset.js